import '../style.css';

const PendingSession = ()=>{
    return (
        <div className='container'>
            <div className='response-overlay'>
            <div className='response-box'>
            <div className='pending-response'>
            <p>Verification Pending</p>
    <div className='description'>
    We are currently unable to proceed. 
   <br/>
    To confirm your verification status, 
    please check back later by clicking on the CLEAR registration link in the initial email request from T-Mobile.
    </div>
    </div>
            </div>
            </div>
    </div>

    )
    
};

export default PendingSession;